<template>    
    <v-layout row wrap justify-end>        
        <v-flex xs1 class="px-3" v-for="action in tileactions">
            <v-btn dark small flat fab v-on:click="actiontriggered(action)">
                <v-icon>{{action.icon}}</v-icon>
            </v-btn>
        </v-flex>
        <v-flex xs1>
            
        </v-flex>
    </v-layout>
</template>
<script>
    
    import { mapGetters } from 'vuex';    
    export default {   
    
    props: [
        'tileactions',
        'item'
    ],
   
    data() {
        return {  
           
                    
        }
    },
    computed: {
        
    },
    methods: {
        actiontriggered(action){this.$emit('actiontriggered', action)},
        
    },
    
    
    
}
</script>
